import PublicActivityType from '@/pages/publicPages/PublicActivityType/PublicActivityType';
import PublicActivityTypeSSP from '@/pages/publicPages/PublicActivityType/PublicActivityType.ssp';
import PageSEO from '@/shared/PageSEO/PageSEO';

export default function Videos(props) {
  return (
    <>
      <PageSEO
        title="Spanish Learning Videos for Kids | Rockalingua"
        description="Explore our collection of engaging Spanish learning videos for kids. Rockalingua offers songs, stories, and interactive content to make learning Spanish fun and effective."
      />
      <PublicActivityType {...props.pageProps} />
    </>
  );
}

export const getServerSideProps = async (context) =>
  await PublicActivityTypeSSP({ context, activityType: 'video' });
